import {Container} from "../Core/Container";
import * as PIXI from "pixi.js";
import {PackageModel} from "../Data/ItemModel";
import {Sprite} from "../Core/Sprite";
import {Anchor} from "../Core/Anchor";
import {texture} from "../Core/AssetHelpers";
import {Application} from "../Application";
import {GameManager} from "../Managers/GameManager";

export class PackageContextMenu extends Container {

    private readonly bg = this.addChild(new Sprite(PIXI.Texture.WHITE, Anchor.middleCenter));

    private readonly items: ContextMenuItem[] = GameManager.instance.allPackages.map(it => this.addChild(new ContextMenuItem(it)));

    constructor(e: PIXI.InteractionEvent, onSelect: (model: PackageModel) => void) {
        super();

        this.bg.width = 10000;
        this.bg.height = 10000;
        this.bg.tint = 0;
        this.bg.alpha = 0.4;
        this.bg.interactive = true;
        this.bg.on("pointerdown", () => this.destroy());

        let x = 0;
        const numColumnItems = 10;
        for (let column = 0; column <= Math.ceil(this.items.length / numColumnItems); column++) {
            let y = 0;
            let w = 0;
            const columnItems = this.items.slice(column * numColumnItems, (column + 1) * numColumnItems);
            for (const item of columnItems) {
                this.addChild(item);
                item.x = x;
                item.y = y;
                y += item.height;
                w = Math.max(item.width, w);
                item.on("pointertap", () => {
                    onSelect(item.model);
                    this.destroy();
                });
            }
            for (const item of columnItems) {
                item.bg.width = w;
            }
            x += w;
        }

        const stage = Application.instance.stage;
        const p = e.data.getLocalPosition(stage);
        stage.addChild(this);
        this.position.set(p.x, p.y);
    }
}

class ContextMenuItem extends Container {

    readonly model: PackageModel;
    readonly bg = this.addChild(new Sprite(PIXI.Texture.WHITE));
    readonly flag: Sprite;
    readonly label: PIXI.Text;

    constructor(model: PackageModel) {
        super();
        this.model = model;

        const p = 8;
        this.flag = this.addChild(new Sprite(texture(`flag-${model.country}`)));
        this.flag.height = 14;
        this.flag.width = 14 * 130 / 94;
        this.flag.x = p;
        this.flag.y = p * 0.5;

        this.label = this.addChild(new PIXI.Text(model.label ?? model.itemType, {
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            fontSize: 14,
            fill: 0x000000,
            align: "left"
        }));

        this.label.x = p + this.flag.x + this.flag.width;
        this.label.y = p * 0.5;
        this.bg.width = this.flag.width + this.label.width + 3 * p;
        this.bg.height = this.label.height + p;
        this.interactive = true;
        this.buttonMode = true;
        this.on("pointerover", () => this.bg.tint = 0xcccccc);
        this.on("pointerout", () => this.bg.tint = 0xffffff);
    }
}